module.exports = __webpack_public_path__ + "img/01_group_photo_2024.e3ad3824.jpg";